/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   Navbar Badge Component
 */

import React from 'react'
import css from '../styles/NavbarBadge.module.scss'

interface Props {
  className?: string
  text?: string
}

export const NavbarBadge = ({ text }: Props) => {
  return <div className={css.badge}>{text}</div>
}
